import { Injectable, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { SeoDefaults, SeoPage } from './seo.model';

@Injectable({ providedIn: 'root' })
export class AppSeoService {
  constructor(
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  apply(page: SeoPage, defaults: SeoDefaults, url?: string) {
    const fullTitle = page.title || '';
    this.title.setTitle(fullTitle);

    // meta de base
    this.meta.updateTag({ name: 'description', content: page.metaDescription || '' });
    this.meta.updateTag({ name: 'robots', content: defaults.robots || 'index,follow' });
    if (page.keywords?.length) {
      this.meta.updateTag({ name: 'keywords', content: page.keywords.join(', ') });
    }

    // OpenGraph
    this.meta.updateTag({ property: 'og:title', content: fullTitle });
    this.meta.updateTag({ property: 'og:description', content: page.metaDescription || '' });
    this.meta.updateTag({ property: 'og:image', content: defaults.image });
    if (url) this.meta.updateTag({ property: 'og:url', content: url });

    // Twitter
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: fullTitle });
    this.meta.updateTag({ name: 'twitter:description', content: page.metaDescription || '' });
    this.meta.updateTag({ name: 'twitter:image', content: defaults.image });

    // Canonical
    this.setCanonical(url);
  }

  private setCanonical(url?: string) {
    if (!url) return;
    let link: HTMLLinkElement | null = this.doc.querySelector("link[rel='canonical']");
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
